import {Component, OnDestroy} from "@angular/core";
import {GlobalSpinnerService} from "@app/services/misc-services/global-spinner.service";

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.css'],
})
export class AppComponent implements OnDestroy {

    constructor(public globalSpinner: GlobalSpinnerService) {}

    ngOnDestroy() {}
}



